import React from 'react';
import { useReveal } from '../lib/useReveal';
export function TrustSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-209">
      <div className="container mx-auto max-w-3xl" data-id="element-210">
        <div ref={ref1} className={`reveal text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-211">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#eab308] mb-8" data-id="element-212">
            ¿Por qué Academia Holística Argentina?
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-213">
            <p data-id="element-214">
              Somos una academia especializada en formación holística para el
              público hispanohablante. Nuestro material está diseñado con rigor,
              profundidad y aplicación práctica, no con teoría vacía.
            </p>

            <div className="bg-gradient-to-br from-[#eab308]/10 to-[#d4a017]/5 border border-[#eab308]/20 rounded-2xl p-8 shadow-lg" data-id="element-215">
              <p className="text-xl md:text-2xl font-serif font-bold text-white leading-tight" data-id="element-216">
                Esta formación fue construida para que puedas aprenderla sola,
                aplicarla en tu vida y, si querés, utilizarla profesionalmente.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}